<template>
  <div class="md-layout md-gutter md-alignment-top-center">
    <TextField label="冷蔵庫ID" type="number" v-model="boxId" @keyup="keyup" @click="searchBox" />
  </div>
</template>

<script>
import TextField from '@/components/parts/TextField';

export default {
  name: 'SelectBox',
  created() {
    this.$parent.title = '冷蔵庫ID入力';
    this.$parent.imageName = '';
    this.$parent.hasMaintenancne = false;
    this.$parent.showMaintenanceInformation = false;
  },
  data() {
    return {
      boxId: '',
    };
  },
  components: {
    TextField,
  },
  methods: {
    searchBox() {
      this.$store.dispatch('getMaintenanceData', { boxId: this.boxId })
        .then(() => { this.$router.push({ name: 'SelectRoute' }); })
        .catch((e) => {
          if (e.status == 401) {
            alert(e.data.error.message);
            this.$router.push({ name: 'SignIn', replace: true })
            return;
          }
          alert(e.data.error.message);
        });
    },
    keyup(e) {
      if (this.boxId !== '' && e.keyCode === 13) {
        this.searchBox();
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/SelectBox.vue?01426a30